import React from 'react';

import SesamLink from '../common/Links/SesamLink';
import { ConnectionString } from './ConnectionString.view';

import './ConnectMessages.scss';

export const UnlicensedMessage: React.FC<{
  subId: string;
  lastUrl: string;
}> = ({ lastUrl, subId }) => (
  <>
    <h2 className="connect-message-title">Not licensed yet</h2>
    <p>
      The subscription at <ConnectionString url={lastUrl} /> does not have a license yet.
    </p>
    <p>
      Goto{' '}
      <SesamLink to={`/subscription/${subId}/settings-subscription/license`}>
        license settings
      </SesamLink>{' '}
      to upload license.
    </p>
  </>
);
